<template>
  <div v-cloak>
    <Card class="points_wrap">
      <!-- 新增上传 -->
      <div v-if="jzzjF_IsReadCommitment() === true">
        <!-- 补充信息 -->

        <supplement v-if="currentStep == appInfoDataType['补充材料信息']" :form="form" @next="next" />

        <!-- 单位基本信息 -->
        <unit-information v-if="currentStep == appInfoDataType['单位基本信息']" :current="appInfoDataType['单位基本信息']" :form="form" :enterpriseAgentList="enterpriseAgentList" :isEnterprise="isEnterprise" @personnalChange="personnalChange"
          @handleSuccess="handleSuccess" @openQrCodeUpload="openQrCodeUpload" @handleFormatError="handleFormatError" @handlePreview="handlePreview" @handleView="handleView" @handleRemove="handleRemove" @submit="submit" @next="next" />
        <!-- 申请人基本信息 -->
        <basic-information v-if="currentStep == appInfoDataType['申请人基本信息']" @handleMaxSize="handleMaxSize" :hasLaborDispatchPermit="hasLaborDispatchPermit" :current="appInfoDataType['申请人基本信息']" :form="form" @handleSuccess="handleSuccess"
          @handleFormatError="handleFormatError" @openQrCodeUpload="openQrCodeUpload" @handleView="handleView" @handlePreview="handlePreview" @handleRemove="handleRemove" @changeDateFmt="changeDateFmt" @submit="submit" @next="next" />
        <!-- 申请人婚姻信息 -->
        <Marriage v-if="currentStep == appInfoDataType['申请人婚姻信息']" :hasLaborDispatchPermit="hasLaborDispatchPermit" :current="appInfoDataType['申请人婚姻信息']" :form="form" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
          @openQrCodeUpload="openQrCodeUpload" @handleView="handleView" @handleMaxSize="handleMaxSize" @handlePreview="handlePreview" @handleRemove="handleRemove" @changeDateFmt="changeDateFmt" @submit="submit" @next="next" />
        <!-- 配偶信息 -->
        <spouse-information v-if="currentStep == appInfoDataType['配偶信息']" @handleMaxSize="handleMaxSize" :current="appInfoDataType['配偶信息']" @handlePreview="handlePreview" :form="form" @handleSuccess="handleSuccess"
          @handleFormatError="handleFormatError" @handleView="handleView" @openQrCodeUpload="openQrCodeUpload" @handleRemove="handleRemove" @next="next" />
        <!-- 子女信息 -->
        <child-information v-if="currentStep == appInfoDataType['子女信息']" @handleMaxSize="handleMaxSize" :current="appInfoDataType['子女信息']" @delSpouseChange="delSpouseChange" @getAgeByCardId="getAgeByCardId" @handlePreview="handlePreview"
          :form="form" @handleSuccess="handleSuccess" @openQrCodeUpload="openQrCodeUpload" @handleFormatError="handleFormatError" @handleView="handleView" @handleRemove="handleRemove" @addChild="addChild" @delChild="delChild"
          @next="next" />
        <!-- 学历信息 -->
        <education-background ref="EducationBackground" v-if="currentStep == appInfoDataType['学历信息']" @openSamplePictures="openSamplePictures" @handleMaxSize="handleMaxSize" :current="appInfoDataType['学历信息']" @handlePreview="handlePreview"
          :form="form" @changeDateFmt="changeDateFmt" @handleSuccess="handleSuccess" @handleView="handleView" @openQrCodeUpload="openQrCodeUpload" @handleFormatError="handleFormatError" @handleRemove="handleRemove" @next="next" />
        <!-- 专科学历信息 -->
        <junior-college ref="EducationBackgroundJuniorCollege" v-if="currentStep == appInfoDataType['专科学历信息']" @openSamplePictures="openSamplePictures" @handleMaxSize="handleMaxSize" :current="appInfoDataType['专科学历信息']"
          @handlePreview="handlePreview" :form="form.juniorCollegeEducation" @changeDateFmt="changeDateFmt" @handleSuccess="handleSuccess" @handleView="handleView" @openQrCodeUpload="openQrCodeUpload" @handleFormatError="handleFormatError"
          @handleRemove="handleRemove" @next="next" />
        <!-- 加分材料 -->
        <bonus-material v-if="currentStep == appInfoDataType['加分材料']" :current="appInfoDataType['加分材料']" :form="form" @handlePreview="handlePreview" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
          @handleView="handleView" @openQrCodeUpload="openQrCodeUpload" @handleRemove="handleRemove" @next="next" @addChild="addChild" @delChild="delChild" @submit="submit" />
        <!-- 个人信息变更 -->
        <change-information v-if="currentStep == appInfoDataType['个人信息变更']" :current="appInfoDataType['个人信息变更']" @handlePreview="handlePreview" :form="form" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
          @handleView="handleView" @openQrCodeUpload="openQrCodeUpload" @handleRemove="handleRemove" @next="next" @submit="submit" />
        <!-- 其他材料 -->
        <other v-if="currentStep == appInfoDataType['补充材料其他材料']" :current="appInfoDataType['补充材料其他材料']" @handlePreview="handlePreview" :form="form" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
          @handleView="handleView" @openQrCodeUpload="openQrCodeUpload" @handleRemove="handleRemove" @next="next" @submit="submit" />
        <!-- qrcode提交页 -->
        <q-r-code-sub v-if="currentStep == appInfoDataType['QrSub']" :current="appInfoDataType['QrSub']" @handlePreview="handlePreview" :form="form" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
          @handleView="handleView" @handleRemove="handleRemove" @next="next" @submit="submit" />
        <!-- 结果页面 -->
        <result-view v-if="currentStep == appInfoDataType['结果页']" :current="appInfoDataType['结果页']" :form="form" :result="result" />
        <qr-code-upload :show="qrCodeUploadShow" @colse="colseQrCodeUpload" :qrcode="qrCodeUpload" :loading="qrCodeLoading" />

      </div>
      <!-- 承诺书 -->
      <div v-else>
        <letter-of-commitment @confirm="confirmLetterOfCommitment"></letter-of-commitment>
      </div>
      <Spin size="large" fix v-if="nextLoading"></Spin>
    </Card>
  </div>
</template>
<script>
import '../styles/points.less'

import LetterOfCommitment from '@/components/letterOfCommitment/index.vue'
import supplement from './supplement/index'
import UnitInformation from './unitInformation/index'
import BasicInformation from './basicInformationRenewal/index'
import Marriage from './marriage/index'
import EducationBackground from './educationBackground/index'
import JuniorCollege from './educationBackground/juniorCollege'
import SpouseInformation from './spouseInformation/index'
import ChildInformation from './childInformation/index'
import BonusMaterial from './bonusMaterial/index'
import ChangeInformation from './changeInformation/index'
import other from './other/renewal'
import QRCodeSub from './QRCodeSub/index'
import resultView from './resultView/index'
import store from '@/store'
import QrCodeUpload from '@/components/qrCodeUploadModel/index'

export default {
  components: {
    supplement,
    LetterOfCommitment,
    UnitInformation,
    BasicInformation,
    Marriage,
    EducationBackground,
    JuniorCollege,
    SpouseInformation,
    ChildInformation,
    BonusMaterial,
    ChangeInformation,
    other,
    QRCodeSub,
    resultView,
    QrCodeUpload,
  },

  data() {
    return {
      qrCodeUpload: '',
      qrCodeLoading: false,
      qrCodeUploadShow: false,
      timer: null,
      appInfoDataType: this.$store.state.appInfoDataType,
      isEnterprise: true, //是否（单位用于禁用经办人下拉框）
      personnalId: null, //经办人Id（当前账号为经办人默认选中下拉框且禁用）
      enterpriseAgentList: [], //经办人列表
      hasLaborDispatchPermit: false, //单位是否有派遣资质
      stepList: [], //需要补充的步骤
      currentStep: 18,
      currentStepIndex: 0, //当前这一步下标
      nextLoading: false,
      form: {
        juniorCollegeEducation: { educationFileGuid: '' },
        supplementaryMaterialOtherFileGuidList: [],
        supplementaryMaterialOtherFileGuid: [],
        supplementaryMaterialTypeDetail: { supplementaryMaterialTypeList: [] },
      },
      currentGuid: '',
      result: { type: 'success', title: '提交成功', desc: '0000000' },
      // ...mapActions(['方法名','方法名'])
    }
  },
  watch: {
    'form.hasPlusTitle': {
      handler(newVal) {
        if (!Array.isArray(this.form.plusTitleList)) {
          this.form.plusTitleList = []
        }
        if (this.form.plusTitleList.length == 0 && newVal) {
          this.addHasPlusTitle()
        }
      },
      immediate: true,
    },
    'form.hasPlusSkillLevel': {
      handler(newVal) {
        if (!Array.isArray(this.form.plusSkillLevelList)) {
          this.form.plusSkillLevelList = []
        }
        if (this.form.plusSkillLevelList.length == 0 && newVal) {
          //   this.$set(this.form, 'plusSkillLevelList', [
          //     {
          //       title: null,
          //       skillLevelCertGuid: null,
          //       otherFileGuidList: [],
          //     },
          //   ])
          this.addHasPlusSkillLevel()
        }
      },
      immediate: true,
    },
    'form.hasPlusRecognitionAward': {
      handler(newVal) {
        if (!Array.isArray(this.form.plusRecognitionAwardList)) {
          this.form.plusRecognitionAwardList = []
        }
        if (this.form.plusRecognitionAwardList.length == 0 && newVal) {
          //   this.$set(this.form, 'plusRecognitionAwardList', [
          //     {
          //       title: null,
          //       recognitionAwardGuid: null,
          //       otherFileGuidList: [],
          //     },
          //   ])
          this.addHasPlusRecognitionAward()
        }
      },
      immediate: true,
    },
    'form.hasPlusInvestmentTaxationDrivingLocalEmployment': {
      handler(newVal) {
        if (!Array.isArray(this.form.plusInvestmentTaxationDrivingLocalEmploymentList)) {
          this.form.plusInvestmentTaxationDrivingLocalEmploymentList = []
        }
        if (this.form.plusInvestmentTaxationDrivingLocalEmploymentList.length == 0 && newVal) {
          //   this.$set(this.form, 'plusInvestmentTaxationDrivingLocalEmploymentList', [
          //     {
          //       enterpriseName: null,
          //       capitalVerificationReportGuid: null,
          //       businessArchivesMachineReadGuid: '',
          //       taxOfLastThreeYearGuid: '',
          //       uploadMaterialType: 0,
          //       taxDetailOfLastThreeYearGuid: '',
          //       otherFileGuidList: [],
          //     },
          //   ])
          this.addHasPlusInvestmentTaxationDrivingLocalEmployment()
        }
      },
      immediate: true,
    },
    'form.hasPlusIncubatorMaterial': {
      handler(newVal) {
        if (!Array.isArray(this.form.plusIncubatorMaterialList)) {
          this.form.plusIncubatorMaterialList = []
        }
        if (this.form.plusIncubatorMaterialList.length == 0 && newVal) {
          //   this.$set(this.form, 'plusIncubatorMaterialList', [
          //     {
          //       title: null,
          //       incubationProtocolGuid: null,
          //       projectContractGuid: '',
          //       businessArchivesMachineReadGuid: '',
          //       proofOfFundsGuid: '',
          //       otherFileGuidList: [],
          //     },
          //   ])
          this.addHasPlusIncubatorMaterial()
        }
      },
      immediate: true,
    },

    'form.isSpouseRegisteredResidenceInSH': {
      handler(newvVal) {
        if (newvVal) {
          this.form.isSpouseEnjoyTreatment = false
        }
      },
    },
    'form.applicantMaritalStatus': {
      handler(newvVal) {
        if (
          newvVal !== this.$store.state.maritalStatusSet['初婚'] ||
          newvVal !== this.$store.state.maritalStatusSet['再婚']
        ) {
          this.form.isSpouseEnjoyTreatment = false
        }
      },
    },

    currentStep: {
      handler(newVal) {
        if (newVal == this.appInfoDataType['加分材料']) {
          if (
            this.form.plusTitleList == undefined ||
            (Array.isArray(this.form.plusTitleList) && this.form.plusTitleList.length == 0)
          ) {
            this.addHasPlusTitle()
          }
        }
      },
      // immediate: true,
    },
  },
  mounted() {
    this.currentGuid = this.$route.query.guid
    if (!this.currentGuid) {
      $Modal.error({
        title: '错误',
        content: '参数错误',
      })
      return
    }
    this.getFullInfo(this.currentGuid, this.currentStep)
  },

  methods: {
    //承诺书是否已读
    jzzjF_IsReadCommitment() {
      return store.state.session.user ? store.state.session.user.jzzjF_IsReadCommitment : ''
    },
    //获取全部信息
    async getFullInfo(guid, loadAppInfoTypes) {
      // guid='d7a4ed15-7dbf-4464-b178-8cf7fdf3a04b'

      if (loadAppInfoTypes == this.$store.state.appInfoDataType['专科学历信息']) {
        loadAppInfoTypes =
          this.$store.state.appInfoDataType['学历信息'] +
          ',' +
          this.$store.state.appInfoDataType['专科学历信息']
      }
      if (loadAppInfoTypes == this.$store.state.appInfoDataType['加分材料']) {
        loadAppInfoTypes =
          this.$store.state.appInfoDataType['学历信息'] +
          ',' +
          this.$store.state.appInfoDataType['加分材料']
      }
      if (loadAppInfoTypes != 18) {
        loadAppInfoTypes += ',18'
      }
      this.nextLoading = true
      try {
        const { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/GetXBAppFullInfo`, {
          params: { guid, loadAppInfoTypes, isDetail: false },
        })
        //数据处理
        if (!data.result.personalInfoChange) {
          data.result.personalInfoChang = {}
        }
        //赋值
        this.form = {
          // ...data.result.spouse,
          childrenList: data.result.childrenList,
          ...data.result.mainInfo,
          ...data.result.spouse,
          ...data.result.education,
          ...data.result.personalInfoChange,
          plusInvestmentTaxationDrivingLocalEmploymentList:
            data.result.plusInvestmentTaxationDrivingLocalEmploymentList,
          plusIncubatorMaterialList: data.result.plusIncubatorMaterialList,
          plusRecognitionAwardList: data.result.plusRecognitionAwardList,
          plusSkillLevelList: data.result.plusSkillLevelList,
          plusTitleList: data.result.plusTitleList,
          spouseList: data.result.spouseList,
          juniorCollegeEducation: data.result.juniorCollegeEducation,
          prequalificationFeedBackList: data.result.prequalificationFeedBackList,
          supplementaryMaterialTypeDetail: data.result.supplementaryMaterialTypeDetail,
        }
        if (
          this.form.supplementaryMaterialTypeDetail.supplementaryMaterialTypeList &&
          this.form.supplementaryMaterialTypeDetail.supplementaryMaterialTypeList.length > 0
        ) {
          let step = []
          this.form.supplementaryMaterialTypeDetail.supplementaryMaterialTypeList.forEach((el) => {
            step.push(el.value)
          })

          this.stepList = [
            this.appInfoDataType['补充材料信息'], //必须
            ...step,
          ]
        }
        this.currentGuid = this.form.guid
        this.form.juniorCollegeEducation.educationType = 2
        /*
        时间处理
         */
        if (this.form.applicantResidencePermitExpiryDate) {
          this.form.applicantResidencePermitExpiryDate = new Date(
            this.form.applicantResidencePermitExpiryDate
          )
        }
        if (this.form.enrolDate) {
          this.form.enrolDate = new Date(this.form.enrolDate)
        }
        if (this.form.graduationDate) {
          this.form.graduationDate = new Date(this.form.graduationDate)
        }
        if (this.form.juniorCollegeEducation.enrolDate) {
          this.form.juniorCollegeEducation.enrolDate = new Date(
            this.form.juniorCollegeEducation.enrolDate
          )
        }
        if (this.form.juniorCollegeEducation.graduationDate) {
          this.form.juniorCollegeEducation.graduationDate = new Date(
            this.form.juniorCollegeEducation.graduationDate
          )
        }
        //
        if (this.form.isChildrenEnjoyTreatment && this.form.childrenList.length < 1) {
          this.$set(this.form, 'childrenList', [
            {
              age: null,
              birthCertificateGuid: '',
              bornByCurrentSpouse: null,
              id: 0,
              idCardNo: '',
              name: '',
              registeredResidenceType: null,
              residenceBookletMainPageGuid: '',
              residenceBookletSelfPageGuid: '',
              fullTimeHighSchoolGuid: '',
              studentCertificateGuid: '',
              adoptionCertificateGuidList: [],
              otherMaterialGuidList: [],
              otherMaterialGuidListPreview: [],
              adoptionCertificateGuidListPreview: [],
            },
          ])
        }

        this.enterpriseAgentList = data.result.basicData.enterpriseAgentList
        this.$store.state.isPassFilesManagementAptitude =
          data.result.basicData.isPassFilesManagementAptitude
        this.isEnterprise = data.result.basicData.isEnterprise
        this.$store.state.enterpriseHasLaborDispatchPermit =
          data.result.basicData.enterpriseHasLaborDispatchPermit
        this.$store.state.enterpriseIsShanghaiBranch =
          data.result.basicData.enterpriseIsShanghaiBranch
        this.isInitAddMaterialInfo()
        this.$store.commit('setMateriaBasicData', data.result.basicData.enumData)
      } catch (error) {}
      this.nextLoading = false
    },
    //默认初始化材料信息
    isInitAddMaterialInfo() {
      if (
        this.form.supplementaryMaterialTypeDetail.isNeedSupplement技术职称 &&
        this.form.plusTitleList.length == 0
      ) {
        this.addHasPlusTitle()
      }
      if (
        this.form.supplementaryMaterialTypeDetail.isNeedSupplement技能等级 &&
        this.form.plusSkillLevelList.length == 0
      ) {
        this.addHasPlusSkillLevel()
      }
      if (
        this.form.supplementaryMaterialTypeDetail.isNeedSupplement表彰奖励 &&
        this.form.plusRecognitionAwardList.length == 0
      ) {
        this.addHasPlusRecognitionAward()
      }
      if (
        this.form.supplementaryMaterialTypeDetail.isNeedSupplement投资纳税 &&
        this.form.plusInvestmentTaxationDrivingLocalEmploymentList.length == 0
      ) {
        this.addHasPlusInvestmentTaxationDrivingLocalEmployment()
      }
      if (
        this.form.supplementaryMaterialTypeDetail.isNeedSupplement孵化器 &&
        this.form.plusIncubatorMaterialList.length == 0
      ) {
        this.addHasPlusIncubatorMaterial()
      }
    },
    //人事更改
    async personnalChange(id) {
      const { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/GetPersonnelInfoById`, {
        params: { id },
      })
      this.form.personnelIDCardNo = data.result.personnelIDCardNo
      this.form.personnelPhone = data.result.personnelPhone
    },

    //下一步
    async next(nextVal, submitUrl) {
      //有提交路径才执行
      let _this = this
      if (submitUrl) {
        let data = await this.submit(submitUrl, 0)
        if (data === false) return //抛出错误不往下执行
      }
      if (this.currentStepIndex + nextVal == this.stepList.length) {
        // 最后一步点击下一步时直接提交
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认提交申请？</p>',
          okText: '是',
          cancelText: '否',
          onOk: async () => {
            // 是 直接提交
            try {
              await this.submit('/api/services/app/JZZJFApi/SubmitApplication', 1, '提交成功')
            } catch (error) {
              _this.$Message.error({
                content: '操作失败',
                background: true,
                duration: 6,
              })
            }
          },
          onCancel: () => {},
        })

        return
      }
      //显示
      this.currentStepIndex = this.currentStepIndex + nextVal
      this.currentStep = this.stepList[this.currentStepIndex]

      this.$nextTick(async () => {
        await _this.getFullInfo(_this.currentGuid, _this.currentStep)
      })
    },
    //职称材料
    addHasPlusTitle() {
      this.$set(this.form, 'plusTitleList', [
        {
          title: null,
          isRegCert: '',
          titleCertGuid: null,
          appointmentFormGuid: null,
          reviewFormGuid: '',
          examLevelFormGuid: '',
          regCertGuid: null,
          otherFileGuidList: [],
          appointmentFormGuidPreview: [],
          examLevelFormGuidPreview: [],
          otherFileGuidListPreview: [],
          regCertGuidPreview: [],
          reviewFormGuidPreview: [],
          titleCertGuidPreview: [],
        },
      ])
    },
    //打开示例图
    openSamplePictures(type) {
      const $viewer = this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: 0,
        },
        images: [this.$baseURL + '/educationBackground/' + type + '.jpg'],
      })
    },
    //技能等级材料
    addHasPlusSkillLevel() {
      this.$set(this.form, 'plusSkillLevelList', [
        {
          title: null,
          skillLevelCertGuid: null,
          otherFileGuidList: [],
          skillLevelCertGuidPreview: [],
          otherFileGuidListPreview: [],
        },
      ])
    },
    //表彰奖励材料
    addHasPlusRecognitionAward() {
      this.$set(this.form, 'plusRecognitionAwardList', [
        {
          title: null,
          recognitionAwardGuid: null,
          otherFileGuidList: [],
          otherFileGuidListPreview: [],
          recognitionAwardGuidPreview: [],
        },
      ])
    },
    //投资纳税带动本地就业材料
    addHasPlusInvestmentTaxationDrivingLocalEmployment() {
      this.$set(this.form, 'plusInvestmentTaxationDrivingLocalEmploymentList', [
        {
          enterpriseName: null,
          capitalVerificationReportGuid: null,
          businessArchivesMachineReadGuid: '',
          taxOfLastThreeYearGuid: '',
          uploadMaterialType: 0,
          taxDetailOfLastThreeYearGuid: '',
          otherFileGuidList: [],
          businessArchivesMachineReadGuidPreview: [],
          capitalVerificationReportGuidPreview: [],
          otherFileGuidListPreview: [],
          taxDetailOfLastThreeYearGuidPreview: [],
          taxOfLastThreeYearGuidPreview: [],
        },
      ])
    },
    //孵化器材料
    addHasPlusIncubatorMaterial() {
      this.$set(this.form, 'plusIncubatorMaterialList', [
        {
          title: null,
          incubationProtocolGuid: null,
          projectContractGuid: '',
          businessArchivesMachineReadGuid: '',
          proofOfFundsGuid: '',
          otherFileGuidList: [],
          businessArchivesMachineReadGuidPreview: [],
          incubationProtocolGuidPreview: [],
          otherFileGuidListPreview: [],
          projectContractGuidPreview: [],
          proofOfFundsGuidPreview: [],
        },
      ])
    },
    //处理提交到服务器的数据
    dataIntegration() {
      if (this.currentStep == this.$store.state.appInfoDataType['专科学历信息']) {
        this.form.juniorCollegeEducation.guid = this.form.guid
        return this.form.juniorCollegeEducation
      } else {
        return this.form
      }
    },
    //提交
    async submit(url, isSubmit, title) {
      this.nextLoading = true
      try {
        let params = this.dataIntegration()
        let data = await this.$Ajax.post(url, params)
        if (isSubmit) {
          this.result.desc = data.data.result
          this.currentStep = this.appInfoDataType['结果页']
        }
        this.nextLoading = false
        return data
        if (title) {
          this.$Message.success({
            content: title,
            background: true,
            duration: 6,
          })
        }
      } catch (error) {
        this.nextLoading = false
        return false
      }
    },
    //删除后判断是否有子女选择了这个
    delSpouseChange(id) {
      this.form.childrenList.map((children, index) => {
        if (children.applicationSpouseId == id) {
          this.$set(this.form.childrenList[index], 'applicationSpouseId', null)
        }
      })
    },
    //通过身份证获取年龄
    async getAgeByCardId(idCard, index) {
      let { data } = await this.$Ajax.post(
        `/api/services/app/JZZJFApi/GetAgeByIdCard?idCard=${idCard}`
      )

      if (data.result !== null) {
        // this.form.childrenList[index].age = data.result
        this.$set(this.form.childrenList[index], 'age', data.result)
      }
    },

    //数组转字符串
    listToStringGuids(property, toProperty) {
      if (this.form[property].length >= 1) {
        this.form[toProperty] = this.form[property].join()
      }
    },
    //字符串转数组
    stringToListGuids(property) {
      if (this.form[property].indexOf(',') > -1) {
        this.form[property] = split(',')
      }
    },

    getGenderFromID(id) {
      // 根据身份证的第17位判断性别（奇数为男，偶数为女）
      var gender = id.charAt(16)

      if (gender % 2 === 0) {
        return '女'
      } else {
        return '男'
      }
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      let _this = this
      let guid = 0

      try {
        if (file.guid) {
          guid = file.guid
        } else if (file.response) {
          guid = file.response.result.guid
        }
      } catch (error) {
        guid = 0
      }
      //   _this.form.articleImages.splice(i, 1)
      if (!this.hasDotOrBracket(property)) {
        // 是否多层属性
        //不是多层属性
        // 判断目标是否为数组，并给其赋值或者插入新数据
        if (isArray) {
          // 是数组
          let arrIndex = this.form[property].indexOf(guid)
          if (arrIndex !== -1) {
            this.form[property].splice(arrIndex, 1)
            if (this.form[property + 'Preview'] != undefined) {
              this.form[property + 'Preview'].splice(arrIndex, 1)
              // this.removeByGuid(this.form[property + 'List'], guid)
            }
          }
        } else {
          // 否则直接赋值
          this.$set(this.form, property, null)
          if (this.form[property + 'Preview'] != undefined) {
            this.removeByGuid(this.form[property + 'Preview'], guid)
          }
        }
        return
      }

      if (this.hasDotOrBracket(property)) {
        //是多层属性
        const keys = property.split(/[.\[\]]/).filter((x) => x)
        let lastIndex = keys.length - 1
        let arr = this.form
        for (let i = 0; i < lastIndex; ++i) {
          arr = arr[keys[i]]
        }
        /* 如果目标是一个数组 */
        if (isArray) {
          // 是数组
          let arrIndex = arr[keys[lastIndex]].indexOf(guid)
          if (arrIndex !== -1) {
            arr[keys[lastIndex]].splice(arrIndex, 1)
            if (arr[keys[lastIndex] + 'Preview'] != undefined) {
              _this.removeByGuid(arr[keys[lastIndex] + 'Preview'], guid)
            }
          }
        } else {
          /* 直接给对应键名键值设定数值*/
          this.setNestedValue(this.form, keys, null)
          if (arr[keys[keys.length - 1] + 'Preview'] != undefined) {
            arr[keys[keys.length - 1] + 'Preview'] = []
          }
        }
      }
    },
    //通过guid移除对象
    removeByGuid(arr, guid) {
      const index = arr.findIndex((item) => item.guid === guid)
      if (index !== -1) {
        arr.splice(index, 1)
      }
    },
    clearFileData(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      // 判断目标是否为数组，不是数组清空上次
      if (!isArray) {
        if (!this.hasDotOrBracket(property)) {
          //不是多层属性
          // 直接赋值
          this.$set(this.form, property, '')
          this.form[property + 'Preview'] = []
        } else {
          //是多层属性
          const keys = property.split(/[.\[\]]/).filter((x) => x)
          let lastIndex = keys.length - 1
          let arr = this.form

          for (let i = 0; i < lastIndex; ++i) {
            arr = arr[keys[i]]
          }
          /* 直接给对应键名键值设定数值*/
          this.setNestedValue(this.form, keys, '')
          //Preview赋值在后
          if (arr[keys[keys.length - 1] + 'Preview'] != undefined) {
            arr[keys[keys.length - 1] + 'Preview'] = []
          }
        }
        //是否有身份证人像面信息,居住证信息
        if (
          isReadInfo === 'idCard' ||
          isReadInfo === 'residencePermit' ||
          isReadInfo === 'spouseIdCard'
        ) {
          readIdInfoAfterToView.map((el) => {
            let key = Object.keys(el)[0]
            // 赋值
            this.$set(this.form, el[key], '')
          })
        }
      }
    },
    //新增文件
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      try {
        if (this.$security_EncriptResponse) {
          response = this.$decryptData(response.data)
        }
      } catch {}
      let _this = this
      this.clearFileData(
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
      //身份证信息
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        if (response.result.success === false) {
          this.$Modal.error({
            title: '错误',
            content: response.result.message,
          })
          return
        }
        if (!(response.result.idCard && response.result.name)) {
          this.$Modal.error({
            title: '错误',
            content: '身份证图片识别失败，请上传清晰完整的身份证人像面图片！',
          })
          return
        }
        //个人申请时
        if (isReadInfo === 'idCard' && this.$store.state.isPerson) {
          if (this.form.applicantIDCardNo.toLowerCase() != response.result.idCard.toLowerCase()) {
            this.$Modal.error({
              title: '错误',
              content: '身份证不符合当前登录人，请重新上传！',
            })
            return
          }
        }
        //配偶时
        if (isReadInfo === 'spouseIdCard') {
          let applicantSex = this.getGenderFromID(this.form.applicantIDCardNo)

          if (applicantSex == response.result.sex) {
            this.$Modal.error({
              title: '错误',
              content: '配偶身份证不符合实际情况，请重新上传！',
            })
            return
          }
        }
      }
      //身份证背面 先判断
      if (isReadInfo === 'idcard_back') {
        if (response.result.isIDCardBackRecognizeSuccessful === false) {
          this.$Modal.error({
            title: '错误',
            content: '身份证国徽面无法识别，请上传正确清晰的身份证国徽面图片！',
          })
          return
        }
        if (response.result.isIDCardValidityPassed === false) {
          this.$Modal.error({
            title: '错误',
            content: '身份证已过期，不允许申请！',
          })
          return
        }
      }

      //居住证信息
      if (isReadInfo === 'residencePermit') {
        if (!response.result.residencePermitExpiryDate) {
          this.$Modal.error({
            title: '错误',
            content: '居住证图片识别失败，请上传清晰完整的居住证正面图片！',
          })
          return
        }
        //判断居住证姓名和身份证姓名是否一致
        if (response.result.name && response.result.name != this.form.applicantName) {
          this.$Modal.error({
            title: '错误',
            content: '居住证姓名与绑定的身份证不符！',
          })
          return
        }
        //判断身份证号和身份证号是否一致
        if (
          response.result.idCard == null ||
          response.result.idCard.toLowerCase() != this.form.applicantIDCardNo.toLowerCase()
        ) {
          this.$Modal.error({
            title: '错误',
            content: '居住证身份证号与绑定的身份证不符！',
          })
          return
        }

        if (response.result.isResidencePermitValidityPassed === false) {
          this.$Modal.error({
            title: '错误',
            content: '有效期不足2个月，请更新有效期',
          })
          return
        }
      }
      if (!this.hasDotOrBracket(property)) {
        // 是否多层属性

        //不是多层属性
        // 判断目标是否为数组，并给其赋值或者插入新数据
        if (isArray) {
          // 是数组
          // if (this.form[property] == undefined) {
          if (!Array.isArray(this.form[property])) {
            //不存在先创建
            this.$set(this.form, property, [])
          }
          let isExistGUID = this.form[property].some((arrele) => arrele === response.result.guid)
          //是否存在,已存在不往下执行
          if (isExistGUID) {
            return
          }
          this.form[property].push(response.result.guid)
          this.form[property + 'Preview'].push({
            guid: response.result.guid,
            name: response.result.fileName,
            url: response.result.imageUrl,
          })
        } else {
          // 否则直接赋值
          this.$set(this.form, property, response.result.guid)
          if (this.form[property + 'Preview'] != undefined) {
            this.form[property + 'Preview'] = []
            this.form[property + 'Preview'].push({
              guid: response.result.guid,
              name: response.result.fileName,
              url: response.result.imageUrl,
            })
          }
        }
      }

      if (this.hasDotOrBracket(property)) {
        //是多层属性
        const keys = property.split(/[.\[\]]/).filter((x) => x)
        let lastIndex = keys.length - 1
        let arr = this.form

        for (let i = 0; i < lastIndex; ++i) {
          arr = arr[keys[i]]
        }

        /* 如果目标是一个数组 */
        // if (Array.isArray(arr[keys[lastIndex]])) {
        if (isArray) {
          // 是数组
          if (!Array.isArray(arr[keys[lastIndex]])) {
            //不存在先创建
            // this.$set(this.form,arr[keys[lastIndex]],[])
            arr[keys[lastIndex]] = []
          }
          let isExistGUID = arr[keys[lastIndex]].some((arrele) => arrele === response.result.guid)
          //是否存在,已存在不往下执行
          if (isExistGUID) {
            return
          }
          arr[keys[lastIndex]].push(response.result.guid)

          if (arr[keys[lastIndex] + 'Preview'] != undefined) {
            arr[keys[lastIndex] + 'Preview'].push({
              guid: response.result.guid,
              name: response.result.fileName,
              url: response.result.imageUrl,
            })
          }
        } else {
          //不是数组/
          /* 直接给对应键名键值设定数值*/
          this.setNestedValue(this.form, keys, response.result.guid)
          //Preview赋值在后
          if (arr[keys[keys.length - 1] + 'Preview'] != undefined) {
            arr[keys[keys.length - 1] + 'Preview'] = [
              {
                guid: response.result.guid,
                name: response.result.fileName,
                url: response.result.imageUrl,
              },
            ]
          }
        }
      }
      //是否有身份证人像面信息,居住证信息
      if (
        isReadInfo === 'idCard' ||
        isReadInfo === 'residencePermit' ||
        isReadInfo === 'spouseIdCard'
      ) {
        readIdInfoAfterToView.map((el) => {
          let key = Object.keys(el)[0]
          if (
            key == 'residencePermitExpiryDate' &&
            response.result[key] != null &&
            response.result[key] != ''
          ) {
            response.result[key] = new Date(response.result[key])
          }
          if (response.result[key] != null && response.result[key] != '') {
            this.$set(this.form, el[key], response.result[key])
          }
        })
      }

      //是否有学历学位信息
      if (isReadInfo === 'readEducation') {
        if (this.currentStep !== this.$store.state.appInfoDataType['专科学历信息']) {
          for (let key in response.result.educationInfo) {
            if (key in this.form) {
              if (
                response.result.educationInfo[key] != null &&
                response.result.educationInfo[key] != ''
              ) {
                if (key == 'enrolDate' || key == 'graduationDate') {
                  response.result.educationInfo[key] = new Date(response.result.educationInfo[key])
                }
                this.form[key] = response.result.educationInfo[key]
                this.$nextTick(() => {
                  const childElement = this.$refs.EducationBackground.$el.querySelector('.' + key)
                  if (childElement) {
                    childElement.classList.add('markedness')
                    this.$refs.EducationBackground.checkedAutoValue()
                  }
                })
              }
            }
          }
        } else {
          //专升本
          for (let key in response.result.educationInfo) {
            if (key in this.form) {
              if (
                response.result.educationInfo[key] != null &&
                response.result.educationInfo[key] != ''
              ) {
                if (key == 'enrolDate' || key == 'graduationDate') {
                  response.result.educationInfo[key] = new Date(response.result.educationInfo[key])
                }
                this.form.juniorCollegeEducation[key] = response.result.educationInfo[key]
                this.$nextTick(() => {
                  const childElement =
                    this.$refs.EducationBackgroundJuniorCollege.$el.querySelector('.' + key)
                  console.log('🚀 ~ this.$nextTick ~ childElement:', childElement)
                  if (childElement) {
                    childElement.classList.add('markedness')
                    this.$refs.EducationBackgroundJuniorCollege.checkedAutoValue()
                  }
                })
              }
            }
          }
          this.form.juniorCollegeEducation.educationType = 2 //专科学历不随文件变
        }
      }
      this.form = this.form
      // this.form[property]
    },
    //打开手机上传
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.qrCodeUpload = ''
      this.qrCodeUploadShow = true
      this.qrCodeLoading = true
      this.getQrCode(property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //获取上传文件小程序码
    async getQrCode(property, isArray, isReadInfo, readIdInfoAfterToView) {
      let params = {}
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        params.fileType = 'idcard_front'
      }
      if (isReadInfo === 'idcard_back') {
        params.fileType = 'idcard_back'
      }
      let { data } = await this.$Ajax.get('/WxApp/GetUploadFileQrcode', {
        params,
      })
      this.qrCodeUpload = data.result.imgBase64String
      this.qrCodeLoading = false
      if (data.result.uploadContextId && data.result.uploadContextId.indexOf('_') > -1) {
        data.result.uploadContextId = data.result.uploadContextId.split('_')[0]
      }
      this.getMiniUpload(
        data.result.uploadContextId,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
    },
    async getMiniUpload(uploadContextId, property, isArray, isReadInfo, readIdInfoAfterToView) {
      let _this = this
      let params = { uploadContextId }
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        params.readIdInfo = true
      }
      if (isReadInfo === 'idcard_back') {
        params.readIdbackAfterUploaded = true
      }
      if (isReadInfo === 'residencePermit') {
        params.readResidencePermit = true
      }
      if (isReadInfo === 'readEducation') {
        params.readEducation = true
      }
      const poll = async () => {
        // try {
        let { data } = await this.$Ajax.get(`/Common/File/GetUploadedFiles`, {
          params,
        })
        let response = {}
        if (data.result.length > 0) {
          //多张时不再获取到就关闭弹窗和轮询,单张时获取到就关闭弹窗和轮询
          if (isArray == false) {
            //单张时只拿一张
            response = {
              result: { ...data.result[0] },
            }
            //添加
            _this.handleSuccess(
              response,
              null,
              null,
              property,
              isArray,
              isReadInfo,
              readIdInfoAfterToView
            )
            //关闭弹窗和轮询
            _this.colseQrCodeUpload()
            return
          } else {
            //多张时
            //循环
            data.result.map((item) => {
              //添加
              _this.handleSuccess(
                { result: item }, //这个为了统一格式
                null,
                null,
                property,
                isArray,
                isReadInfo,
                readIdInfoAfterToView
              )
            })
          }
        }
        //弹窗打开时发起下一次轮询
        if (_this.qrCodeUploadShow) {
          _this.timer = setTimeout(poll, 2500)
        }
      }
      poll()
    },
    colseQrCodeUpload() {
      this.qrCodeUploadShow = false
      clearTimeout(this.timer)
      this.timer = null
    },

    //文件大小超出
    handleMaxSize(file) {
      this.$Message.error({
        content: '文件' + file.name + ' 过大, 请上传小于5M的文件',
        background: true,
        duration: 6,
      })
    },
    //查看图片文件
    handleView(guid) {
      let _this = this

      const $viewer = this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: 0,
        },
        images: [_this.$baseURL + '/file/preview/' + guid],
      })
    },
    //查看文件
    handlePreview(file) {
      if (typeof file !== 'object') {
        //单个图片
        // window.open(this.$baseURL + '/file/preview/' + file)
        const $viewer = this.$viewerApi({
          options: {
            toolbar: true,
            initialViewIndex: 0,
          },
          images: [this.$baseURL + '/file/preview/' + file],
        })
        return
      }
      let _this = this
      if (file.url) {
        let fileExtension
        if (file.name.indexOf('.') >= 0) {
          fileExtension = file.name.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }

        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.url],
          })
          return
        }
        window.open(this.$baseURL + file.url)
        return
      }
      if (file.status == 'finished') {
        let fileExtension
        if (file.url.indexOf('.') >= 0) {
          fileExtension = file.response.result.fileName.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.response.result.imageUrl],
          })
          return
        }
        window.open(this.$baseURL + file.response.result.imageUrl)
      }
    },
    //判断字符串是不是有.  [  ]
    hasDotOrBracket(str) {
      const regex = /[.\[\]]/
      return regex.test(str)
    },
    //字符串转多层属性 处理
    setNestedValue(obj, keys, value) {
      let lastKey = null
      keys.forEach((key, i) => {
        if (i === keys.length - 1) {
          obj[key] = value // 到达最内层赋值给目标属性
        } else {
          if (!obj[key]) {
            // 如果当前层次还不存在，则初始化他
            this.$set(obj, key, {})
          }
          obj = obj[key]
        }
      })
    },
    changeDateFmt(dateFmt, date, property) {
      this.form[property] = dateFmt
    },
    //文件格式错误
    handleFormatError(file) {
      // this.$Notice.warning({
      //   title: '文件格式错误',
      //   // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      // })
      this.$Message.error({
        content: '文件格式错误',
        background: true,
        duration: 6,
      })
    },

    //移除表单验证
    resmove(name) {
      this.$refs[name].resetFields()
    },
    //添加子项
    addChild(property, collapse) {
      if (!Array.isArray(this.form[property])) {
        this.$set(this.form, property, [])
      }
      if (this.currentStep == this.appInfoDataType['子女信息']) {
        //子女信息
        this.form[property].push({
          age: null,
          birthCertificateGuid: '',
          bornByCurrentSpouse: null,
          id: 0,
          idCardNo: '',
          name: '',
          registeredResidenceType: null,
          residenceBookletMainPageGuid: '',
          residenceBookletSelfPageGuid: '',
          fullTimeHighSchoolGuid: '',
          studentCertificateGuid: '',
          adoptionCertificateGuidList: [],
          otherMaterialGuidList: [],
          otherMaterialGuidListPreview: [],
          adoptionCertificateGuidListPreview: [],
        })
        return
      } else {
        //材料
        if (collapse == 'collapse1') {
          this.form[property].push({
            title: null,
            isRegCert: '',
            titleCertGuid: null,
            appointmentFormGuid: null,
            reviewFormGuid: '',
            examLevelFormGuid: '',
            regCertGuid: null,
            otherFileGuidList: [],
          })
          return
        }
        if (collapse == 'collapse2') {
          this.form[property].push({
            title: null,
            skillLevelCertGuid: null,
            otherFileGuidList: [],
          })
          return
        }
        if (collapse == 'collapse3') {
          this.form[property].push({
            title: null,
            recognitionAwardGuid: null,
            otherFileGuidList: [],
          })
          return
        }
        if (collapse == 'collapse4') {
          this.form[property].push({
            enterpriseName: null,
            capitalVerificationReportGuid: null,
            businessArchivesMachineReadGuid: '',
            taxOfLastThreeYearGuid: '',
            uploadMaterialType: 0,
            taxDetailOfLastThreeYearGuid: '',
            otherFileGuidList: [],
          })
          return
        }
        if (collapse == 'collapse5') {
          this.form[property].push({
            title: null,
            incubationProtocolGuid: null,
            projectContractGuid: '',
            businessArchivesMachineReadGuid: '',
            proofOfFundsGuid: '',
            otherFileGuidList: [],
          })
          return
        }
      }
    },
    //删除子项
    delChild(property, index) {
      this.form[property].splice(index, 1)
    },

    //确认阅读承诺书
    async confirmLetterOfCommitment(val) {
      try {
        let { data } = await this.$Ajax.post(`/api/services/app/JZZJFApi/ReadCommitment`)
        store.state.session.user.jzzjF_IsReadCommitment = true
        return
      } catch (error) {
        this.$Message.error({
          content: '出错了',
          background: true,
          duration: 6,
        })
      }
    },
  },
}
</script>

